import type { ComponentType } from 'react';
import type { FormBlock } from '../types';
import { Header } from '../blocks/Header';
import { Notice } from '../blocks/Notice';
import { FormField } from '../blocks/FormField';
import { SubmitButton } from '../blocks/SubmitButton';

export const blockRegistry: Record<
  string,
  ComponentType<{ block: FormBlock }>
> = {
  header: Header,
  notice: Notice,
  field_section: FormField,
  submit_button: SubmitButton,
};
